<!-- country-select.component.html -->
<div class="country-select inside" [class.open]="isOpen">
  <div class="flag-dropdown" (click)="toggle()" tabindex="0" role="button" aria-haspopup="listbox" [attr.aria-expanded]="isOpen">
    <div class="selected-flag">
      <div class="flag" [ngClass]="current.flag"></div>
      <div class="arrow" [class.up]="isOpen"></div>
    </div>
  </div>

  @if (isOpen) {
    <ul class="country-list" role="listbox">
      @for (l of items; track l; let i = $index) {
        <li
          class="country"
          [class.active]="l.lang === current.lang"
          [attr.data-country-code]="l.flag"
          id="cs-opt-{{i}}"
          tabindex="0"
          role="option"
          (click)="select(l)"
          (keydown)="onKeydownList($event,i)"
          >
          <div class="flag" [ngClass]="l.flag"></div>
          <span class="country-name" aria-hidden="true">{{ l.name }}</span>
        </li>
      }
    </ul>
  }
</div>
